import { GetUserSkillNudgesQuery } from './useUserSkillNudges';

export const updateUserSkillNudgesCache = ({ cache, userUri, nudgeIds }) => {
  if (!nudgeIds) return;

  const cachedData = cache.readQuery({
    query: GetUserSkillNudgesQuery,
    variables: { userUri }
  });
  const cachedUserNudges = cachedData?.userNudges || {};
  const cachedSkillNudges = cachedUserNudges?.skillNudges || [];

  cache.writeQuery({
    query: GetUserSkillNudgesQuery,
    variables: { userUri },
    data: {
      userNudges: {
        ...cachedUserNudges,
        id: userUri,
        skillNudges: cachedSkillNudges.filter(
          skill => !nudgeIds.find(nudgeId => nudgeId === skill.nudgeId)
        )
      }
    }
  });
};

export const clearUserSkillNudgesCache = ({ cache, userUri }) => {
  const cachedData = cache.readQuery({
    query: GetUserSkillNudgesQuery,
    variables: { userUri }
  });
  const cachedUserNudges = cachedData?.userNudges || {};

  cache.writeQuery({
    query: GetUserSkillNudgesQuery,
    variables: { userUri },
    data: {
      userNudges: {
        ...cachedUserNudges,
        skillNudges: []
      }
    }
  });
};
